import { createContext, useState, useContext, useRef, useLayoutEffect } from 'react'
import useStateRef from 'react-usestateref'

const WindowVisibilityContext = createContext()
const WindowVisibilityProvider = ({ children }) => {
  const [isWindowVisible, setIsWindowVisible] = useStateRef(true)

  useLayoutEffect(() => {
    document.addEventListener('visibilitychange', visibilityListener)
    return () => document.removeEventListener('visibilitychange', visibilityListener)
  }, [])

  const visibilityListener = () => {
    if (document.visibilityState === 'hidden') {
      console.log('USER LEFT TAB');
      setIsWindowVisible(false)
    } else {
      console.log('USER RETURNED TO TAB');
      setIsWindowVisible(true)
    }
  }

  return (
    <WindowVisibilityContext.Provider value={{
      isWindowVisible,
    }}>
      {children}
    </WindowVisibilityContext.Provider>
  )
}

const useWindowVisibilityContext = () => useContext(WindowVisibilityContext)

export default useWindowVisibilityContext

export { WindowVisibilityContext, WindowVisibilityProvider, useWindowVisibilityContext }
